import { render, staticRenderFns } from "./ProductTypeFormation.vue?vue&type=template&id=261ee014&scoped=true"
import script from "./ProductTypeFormation.vue?vue&type=script&lang=js"
export * from "./ProductTypeFormation.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeFormation.vue?vue&type=style&index=0&id=261ee014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ee014",
  null
  
)

export default component.exports